/**
 * Resolve GIF URL for a move:
 * - DB `gifUrl` wins (admin-hosted per-move)
 * - If `REACT_APP_MOVES_CDN_BASE_URL` is set, use `${base}/moves/:id.gif`
 * - Else, optional mapping (legacy Cloudinary) can override
 * - Finally fallback to static `/moves/:id.gif`
 * @param {object} move
 * @param {Record<string, string>} [cloudinaryByMoveId]
 */
export function resolveMoveGifUrl(move, cloudinaryByMoveId = {}) {
  if (!move?.moveId) return null;
  if (move.gifUrl) return move.gifUrl;

  const base = (process.env.REACT_APP_MOVES_CDN_BASE_URL || '').replace(/\/+$/, '');
  if (base) {
    return `${base}/moves/${move.moveId}.gif`;
  }

  const mapped = cloudinaryByMoveId[move.moveId];
  if (mapped) return mapped;
  return `/moves/${move.moveId}.gif`;
}
